import { render, staticRenderFns } from "./AccessAuthority.vue?vue&type=template&id=27c00aca&scoped=true"
import script from "./AccessAuthority.vue?vue&type=script&lang=js"
export * from "./AccessAuthority.vue?vue&type=script&lang=js"
import style0 from "./AccessAuthority.vue?vue&type=style&index=0&id=27c00aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c00aca",
  null
  
)

export default component.exports